import { getAppBar, getLocaleSwitch, useLocale } from "@dgs/core";
import { FC } from "react";
import { useFrontendConfig } from "./config/useFrontendConfig";

const AppBar = getAppBar();
const LocaleSwitch = getLocaleSwitch();

export const PublicApplicationBar: FC = () => {
	const { appIdentifier, logo, languageSettings } = useFrontendConfig();
	const { language, setLanguage } = useLocale();

	return (
		<AppBar appIdentifier={appIdentifier} logo={{ logoUrl: logo, logoAltText: appIdentifier || "" }}>
			<LocaleSwitch setLocale={setLanguage} locale={language} availableLocales={languageSettings.availableLanguages} />
		</AppBar>
	);
};
